import { ApprovalMethodDateType } from "./model";
export function isAutoApproval(approvalMethod) {
  return approvalMethod.type === ApprovalMethodDateType.Auto;
}
export function autoApprovalDate(approvalMethod) {
  return isAutoApproval(approvalMethod) ? new Date(approvalMethod.auto.approveDate) : null;
}